import { FilterUtils } from '@elotech/components';
import { isNumber } from 'common/utils';
import { axios } from 'libs';

const resource = '/tiposnotificacao';
const defaultSort = { sort: 'id.id,asc' };

export const findAllAutocomplete = (
  searchParam = '',
  pagination,
  sort = defaultSort
) => {
  let search = isNumber(searchParam)
    ? `id.id==${searchParam}`
    : FilterUtils.buildFilter(['descricao'])(searchParam);

  search += ' and ativo==true';

  return axios.get(resource, {
    params: {
      search,
      ...pagination,
      ...sort
    }
  });
};

export const findAll = (search = '', pagination, sort = defaultSort) => {
  return axios.get(resource, {
    params: {
      search,
      ...pagination,
      ...sort
    }
  });
};

export const deleteById = id => {
  return axios.delete(`${resource}/${id}`);
};

export const findById = id => {
  return axios.get(`${resource}/${id}`);
};

export const save = tipoNotificacao => {
  return tipoNotificacao.id
    ? axios.put(`${resource}/${tipoNotificacao.id}`, tipoNotificacao)
    : axios.post(resource, tipoNotificacao);
};
